import Vue from 'vue';
import Vuex from 'vuex';
import StoreData from './store';
import 'livewire-vue';
import vSelect from 'vue-select';
import SearchDevelopmentsForm from './vue/components/SearchDevelopmentsForm.vue';
import SearchLocationForm from './vue/components/SearchLocationForm.vue';
import SearchForm from './vue/components/SearchForm.vue';
import PropertyAlertForm from './vue/components/PropertyAlertForm.vue';
import MemberPropertyAlertForm from './vue/components/MemberPropertyAlertForm.vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import QuickSearchOpener from './vue/components/QuickSearchOpener.vue';
import QuickSearch from './vue/components/QuickSearch.vue';

window.Vue = Vue;

Vue.use(Vuex);
const store = new Vuex.Store(StoreData);

require('./bootstrap');

Vue.use(VueToast, {
    position: 'top'
});

vSelect.props.components.default = () => ({
    /*
    Deselect: {
        render: createElement => createElement('span', ''),
    },
    */
    OpenIndicator: {
        render: createElement => createElement('span', ''),
    },
});

Vue.component('v-select', vSelect);
Vue.component('property-alert-form', PropertyAlertForm);
Vue.component('member-property-alert-form', MemberPropertyAlertForm);
Vue.component('search-developments-form', SearchDevelopmentsForm);
Vue.component('search-location-form', SearchLocationForm);
Vue.component('search-form', SearchForm);
Vue.component('quicksearch-opener', QuickSearchOpener);
Vue.component('quicksearch', QuickSearch);

var app = new Vue({
    el: '#app',
    store: store,
});
